import React from 'react';
import PropTypes from 'prop-types';

const Choice = ({ size, newName, toggleFunction, isChecked }) => {
  return (
    <div
      className={isChecked ? 'button checked' : 'button'}
      onClick={() => toggleFunction(size)}
    >
      <label htmlFor={size}>{size}</label>
      <input
        name={newName || 'radio'}
        type="radio"
        className="choice"
        value={size}
      />
    </div>
  );
};

Choice.propTypes = {
  size: PropTypes.string,
  newName: PropTypes.string,
  toggleFunction: PropTypes.func,
  isChecked: PropTypes.bool,
};

export default Choice;
